<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-list-address"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body pb-4">
                    <AddressList
                            ref="address-list"
                            @onEditAddress="clickEditAddress($event)"
                            @onDeleteAddress="clickDeleteAddress($event)"
                    ></AddressList>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-primary mr-2" @click="clickAddAddress()">Add New Address</button>
                    <button class="btn btn-secondary" @click="hide()">Close</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import AddressList from "@/module/Address/DeliveryAddress/component/AddressList.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ListAddressModal",
    mixins: [ErrorApiMixin],
    components: {
        AddressList,
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            busModal: null,
            lbl: Locale.getLbl(),

            // addressModel: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden();
        },
        show: function() {
            // this.addressModel = this.controller.address;
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        reloadAddressList: function() {
            this.$refs['address-list'].getAddressList();
        },

        //#region address event
        clickAddAddress: function() {
            this.hide();
            this.controller.addAddressModal.show();
            this.controller.addAddressModal.onClickCancel(() => {
                this.show();
            });
            this.controller.addAddressModal.onAddSuccess((address) => {
                if (!this.controller.notShowModalAfterUpdate) {
                    this.show();
                    this.$nextTick(() => {
                        this.reloadAddressList();
                    });
                }
                this.controller.sendCallbackAddSuccess(address);
                this.controller.sendCallbackUpdateSuccess(address);
            });
        },
        clickEditAddress: function(address) {
            this.hide();

            this.controller.editAddressModal.setAddress(address).show();
            this.controller.editAddressModal.onClickCancel(() => {
                this.show();
            });
            this.controller.editAddressModal.onEditSuccess(() => {
                if (!this.controller.notShowModalAfterUpdate) {
                    this.show();
                    this.$nextTick(() => {
                        this.reloadAddressList();
                    });
                }

                this.controller.sendCallbackEditSuccess(address);
                this.controller.sendCallbackUpdateSuccess(address);
            });
        },
        clickDeleteAddress: function(address) {
            this.hide();

            this.controller.confirmModal.clearModal()
                    .setMsg("ต้องการลบ Address " + address.addressName + " ?")
                    .show();

            this.controller.confirmModal.onClickOk(async () => {
                this.controller.loadingModal.show();
                await this.apiDeleteAddress(address);
                this.controller.loadingModal.hide();

                this.show();
                this.$nextTick(() => {
                    this.reloadAddressList();
                });
            });

            this.controller.confirmModal.onClickCancel(() => {
                this.show();
            });
        },
        //#endregion address event

        //#region api
        apiDeleteAddress: function(address) {
            return new Promise((resolve) => {
                let token = Account.getToken();
                BzbsAddressList.apiDeleteAddress(token, address.rowKey).subscribe(() => {
                    resolve();
                }, (err) => {
                    this.errorApi(err);
                    resolve();
                });
            });
        },
        //#endregion api
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-list-address {
        @extend %modal-base;
    }
</style>
